var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_443_16115",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0H0V30H31V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_443_16115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.499 0H8.49902C4.08074 0 0.499023 3.58172 0.499023 8V22C0.499023 26.4183 4.08074 30 8.49902 30H22.499C26.9173 30 30.499 26.4183 30.499 22V8C30.499 3.58172 26.9173 0 22.499 0Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8004 6.59961H10.469L7.66895 9.39962L10.469 12.1996H14.8004V20.9997H12.4004V22.5997H18.8004V20.9997H16.4004V16.1996H20.7317L23.5318 13.3996L20.7317 10.5996H16.4004V6.59961H15.6004H14.8004ZM14.8004 8.19961H11.1317L9.93169 9.39962L11.1317 10.5996H14.8004V8.19961ZM16.4004 12.1996V14.5996H20.069L21.269 13.3996L20.069 12.1996H16.4004Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0.5H8.5C4.35786 0.5 1 3.85786 1 8V22C1 26.1421 4.35786 29.5 8.5 29.5H22.5C26.6421 29.5 30 26.1421 30 22V8C30 3.85786 26.6421 0.5 22.5 0.5Z",
    stroke: "white",
    strokeOpacity: 0.04
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.af0c0b3c4b05da14ae0f91ac45878305.svg";
export { ForwardRef as ReactComponent };